import LoginError from './LoginError';
class InvalidToken extends LoginError {
    constructor(options) {
        super('Token provided by user is not valid', options);
    }
}
export default InvalidToken;
